export default __webpack_public_path__ + "static/media/American_Express_Logo.8a481328.svg";